'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var reactQuery = require('react-query');
var ReturnsLayout = require('../Layout/ReturnsLayout.js');
var useReturns = require('../../hooks/useReturns.js');
var generated = require('../../graphql/generated.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemSelectionPage = () => {
  const {
    client,
    orderData,
    selectedItems,
    submittedReturnsForOrder,
    setReturnCart,
    setSelectedPudoOption,
    setSubmittedReturn,
    setOrderData,
    setSubmittedReturnsForOrder
  } = useReturns["default"]();
  const [cancelReturnStatus, setCancelReturnStatus] = React.useState({
    status: 'default'
  });
  const navigate = reactRouterDom.useNavigate();
  const resetApp = React.useRef(() => {
    var _orderData$items;
    setReturnCart(undefined);
    setSelectedPudoOption(undefined);
    setSubmittedReturn(undefined);
    if (!(orderData !== null && orderData !== void 0 && orderData.items) || !((orderData === null || orderData === void 0 ? void 0 : (_orderData$items = orderData.items) === null || _orderData$items === void 0 ? void 0 : _orderData$items.length) > 0)) {
      navigate('/');
    }
  });
  const {
    mutate: cancelReturn
  } = reactQuery.useMutation({
    onError: () => setCancelReturnStatus({
      status: 'error'
    }),
    mutationFn: async submittedReturnId => {
      if (!client) throw new Error('Client not initialized');
      if (!(orderData !== null && orderData !== void 0 && orderData.orderId)) throw new Error('Missing order info');
      setCancelReturnStatus({
        status: 'loading',
        returnId: submittedReturnId
      });
      const {
        data: cancelData
      } = await client.mutate({
        mutation: generated.CancelSubmittedReturnDocument,
        variables: {
          returnId: submittedReturnId
        }
      });
      if (!(cancelData !== null && cancelData !== void 0 && cancelData.cancelSubmittedReturn) || cancelData.cancelSubmittedReturn.status !== 'CANCELLED') {
        setCancelReturnStatus({
          status: 'error'
        });
        throw new Error('Cancel unsuccessful');
      }
      const {
        data: {
          getOrderInfo,
          getSubmittedReturnsForOrder
        }
      } = await client.query({
        query: generated.GetOrderInfoAndSubmittedReturnsDocument,
        variables: {
          orderId: orderData.orderId
        }
      });
      if (getOrderInfo) {
        setOrderData(getOrderInfo);
      }
      if (getSubmittedReturnsForOrder) {
        setSubmittedReturnsForOrder(getSubmittedReturnsForOrder.filter(_ref => {
          let {
            status
          } = _ref;
          return status !== 'CANCELLED';
        }));
      }
      setCancelReturnStatus({
        status: 'success'
      });
    }
  });
  React.useEffect(() => {
    resetApp.current();
  }, []);
  const handleClick = e => {
    if (e.subComponent === 'itemPickerList') {
      var _e$value, _e$value$item, _e$value2, _e$value2$item;
      const sku = encodeURIComponent(((_e$value = e.value) === null || _e$value === void 0 ? void 0 : (_e$value$item = _e$value.item) === null || _e$value$item === void 0 ? void 0 : _e$value$item.sku) || '');
      const itemId = encodeURIComponent(((_e$value2 = e.value) === null || _e$value2 === void 0 ? void 0 : (_e$value2$item = _e$value2.item) === null || _e$value2$item === void 0 ? void 0 : _e$value2$item.itemId) || '');
      const urlSearchParams = reactRouterDom.createSearchParams({
        sku,
        itemId
      }).toString();
      navigate(`/items/reasons?${urlSearchParams}`);
    }
    if (e.subComponent === 'returnToLogin') {
      navigate('/');
    }
  };
  const handleCancel = e => {
    var _e$value3, _e$value3$submittedRe;
    const submittedReturnId = (_e$value3 = e.value) === null || _e$value3 === void 0 ? void 0 : (_e$value3$submittedRe = _e$value3.submittedReturn) === null || _e$value3$submittedRe === void 0 ? void 0 : _e$value3$submittedRe.id;
    if (!submittedReturnId) {
      setCancelReturnStatus({
        status: 'error'
      });
      return;
    }
    cancelReturn(submittedReturnId);
  };
  return /*#__PURE__*/React__default["default"].createElement(ReturnsLayout["default"], {
    itemSelector: {
      allItems: (orderData === null || orderData === void 0 ? void 0 : orderData.items) || [],
      selectedItems,
      submittedReturns: submittedReturnsForOrder,
      onClick: handleClick,
      onSubmit: () => {
        navigate('/pudo');
      },
      onCancel: handleCancel,
      cancelReturnStatus,
      features: {
        returnToLogin: true
      }
    }
  });
};

exports["default"] = ItemSelectionPage;
